import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTextInfo } from "../../store/actions";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import SocialMedia from "../../components/commonSection/social-media/SocialMedia";
import FooterMenu from "./FooterMenu";
import FooterApk from "./FooterApk";
import { TextDataScript } from "../../pages/utility/TextDataScript";
import ErrorBoundary from '../../helpers/ExceptionHandler/componentException';


const Footer = ({ t }) => {
  const dispatch = useDispatch();

  // Combine selectors into one for better performance
  const { copyrightInformation, componentSetting } = useSelector((state) => ({
    copyrightInformation: state.textInformationListR.data,
    componentSetting: state.componentSettingListR.data,
  }));

  useEffect(() => {
    dispatch(fetchTextInfo("copyright"));
  }, [dispatch]);

  const hasSocialMedia = componentSetting?.["social-media"]?.["default-value"];
  const footerMenuVisible = componentSetting?.custom_loading?.options?.footer_menu;
  const copyrightText = copyrightInformation?.code === "copyright"
    ? copyrightInformation?.value
    : "";

  return (
    <>
      <TextDataScript payload='custom_script' />
      <footer className="footer background-footer">
        <div className="container">
          <div className="footer_cont">
            <div className="content">
              <h2 className="title text-footer_heading">{t("connect_with_us")}</h2>
              <div className="so-if">
                {hasSocialMedia && <ErrorBoundary><SocialMedia /></ErrorBoundary>}
              </div>
            </div>
            {footerMenuVisible && (
              <>
                <ErrorBoundary>
                  <FooterMenu />
                </ErrorBoundary>

                <ErrorBoundary>
                  <FooterApk />
                </ErrorBoundary>
              </>
            )}
          </div>
          <div className="footer_copy mt-4">
            <p className="footer-p text-heading_copyright_footer">{copyrightText}</p>
            {process.env.REACT_APP_ENV !== 'prod' && (
              <p className="footer-p text-heading_copyright_footer">
                {t('build_version')}: {process.env.REACT_APP_BUILD_NUMBER}
              </p>
            )}
          </div>
        </div>
      </footer>
    </>
  );
};

Footer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Footer);
